import Link from 'next/link';
import Dot from '../icon/Dot';
import { Url } from '../types';

type Props = {
  items?: Url[];
  type?: 'gradient' | 'background_image' | 'live' | 'team' | 'news';
};

export default function Breadcrumb({ type, items }: Props) {
  let color = 'text-white';
  let opacityValue = '0.4';
  let fill = 'white';

  if (type === 'news') {
    color = 'text-gray-400';
    opacityValue = '0.2';
    fill = 'gray';
  } else if (type === 'team') {
    color = 'text-white';
  }

  const elementClass = 'inline-block align-middle';
  const separator = (
    <span className={`mx-[10px] ${elementClass}`}>
      <Dot opacity={opacityValue} fill={fill} />
    </span>
  );

  return (
    <ul
      className={`relative text-xs font-semibold ${color} truncate text-nowrap antialiased`}
      aria-label="breadcrumb"
    >
      {items &&
        items.map((child, index) => (
          <li key={index} className={`${elementClass} capitalize`}>
            {(child?.url && items.length - 1 !== index && (
              <Link href={child?.url}>{child?.linkText}</Link>
            )) ||
              child?.linkText || ''}

            {index < items.length - 1 && separator}
          </li>
        ))}
    </ul>
  );
}
